import { createApp } from 'vue';
import App from './components/App.vue';

createApp(App).mount('#app');